<template>
    <div class="more-con">
        <ul class="all-list">
            <li v-for="item in artcleList" :key="item.firstCategory_id">
                <h4 class="list-title">{{item.title}}</h4>
                <div v-if="item.actitle_list">
                   <p v-for="(sub,index) of item.actitle_list" :key="index">
                       {{sub.title}}
                   </p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js";
export default{
    name: 'HasMoreArticle',
    data () {
        return {
            artcleList: []
        }
    },
    mounted () {
        doPost(
            {action:'get_secondCategory',firstCategory_id: this.$route.query.id, firstCategory_title: this.$route.query.title},
            (res) => {
                console.log(res.data)
                if(res.data.length >= 0) {
                    this.artcleList = res.data
                    console.log(this.artcleList)
                }
            }
        )
        
    }
}
</script>

<style lang="stylus" scoped>
    .more-con
        display inline-block
        margin-left 36px
        .all-list li
            margin-bottom .625rem
        .all-list p
            padding 10px 10px;
        .all-list p:hover
            color #2bd3a0
        .list-title
            padding 10px 0
            font-size 20px
     @media screen and (max-width: 758px)
        .more-con
            margin 0

</style>



// WEBPACK FOOTER //
// src/pages/Tutorial/components/HasMoreArticle.vue